import { objectOf, oneOfType, string, object, array, number, bool } from 'prop-types';

export const candidateProfileData = objectOf(oneOfType([
  string,
  object,
  array,
  number,
  bool,
]));
